import * as actionTypes from "./actionTypes";

const initialPagination = { totalCount: 0 };

const initialState = {
  fetchReferenceEntriesLoading: true,
  referenceEntriesData: {},
  pagination: initialPagination,
  referenceEntryLoading: false,
  referenceEntrySuccess: false,
  deleteReferenceEntrySuccess: false,
  deleteReferenceEntryLoading: false,
  errorMessage: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.FETCH_REFERENCE_ENTRIES:
      return {
        ...state,
        fetchReferenceEntriesLoading: true,
        errorMessage: "",
      };

    case actionTypes.FETCH_REFERENCE_ENTRIES_SUCCESS:
      return {
        ...state,
        fetchReferenceEntriesLoading: false,
        referenceEntriesData: action.payload.data.reduce(
          (acc, referenceEntry) => ({
            ...acc,
            [referenceEntry.id]: referenceEntry,
          }),
          {}
        ),
        pagination: action.payload.meta || state.pagination,
      };

    case actionTypes.FETCH_REFERENCE_ENTRIES_FAILED:
      return {
        ...state,
        fetchReferenceEntriesLoading: false,
        referenceEntriesData: {},
        pagination: initialPagination,
        errorMessage: action.payload,
      };

    case actionTypes.CREATE_REFERENCE_ENTRY:
      return {
        ...state,
        referenceEntryLoading: true,
        errorMessage: "",
        referenceEntrySuccess: false,
      };

    case actionTypes.CREATE_REFERENCE_ENTRY_SUCCESS:
      return {
        ...state,
        referenceEntryLoading: false,
        referenceEntriesData: {
          ...state.referenceEntriesData,
          [action.payload.id]: action.payload,
        },
        pagination: {
          ...state.pagination,
          totalCount: state.pagination.totalCount + 1,
        },
        referenceEntrySuccess: true,
      };

    case actionTypes.CREATE_REFERENCE_ENTRY_FAILED:
      return {
        ...state,
        referenceEntryLoading: false,
        errorMessage: action.payload,
      };

    case actionTypes.UPDATE_REFERENCE_ENTRY:
      return {
        ...state,
        referenceEntryLoading: true,
        errorMessage: "",
        referenceEntrySuccess: false,
      };

    case actionTypes.UPDATE_REFERENCE_ENTRY_SUCCESS:
      return {
        ...state,
        referenceEntryLoading: false,
        referenceEntriesData: {
          ...state.referenceEntriesData,
          [action.payload.id]: action.payload,
        },
        referenceEntrySuccess: true,
      };

    case actionTypes.UPDATE_REFERENCE_ENTRY_FAILED:
      return {
        ...state,
        referenceEntryLoading: false,
        errorMessage: action.payload,
      };

    case actionTypes.DELETE_REFERENCE_ENTRY:
      return {
        ...state,
        deleteReferenceEntryLoading: true,
        errorMessage: "",
        deleteReferenceEntrySuccess: false,
      };

    case actionTypes.DELETE_REFERENCE_ENTRY_SUCCESS: {
      const { id } = action.payload;
      const { [id]: deletedEntry, ...remainingEntries } =
        state.referenceEntriesData;
      return {
        ...state,
        deleteReferenceEntryLoading: false,
        referenceEntriesData: remainingEntries,
        pagination: {
          ...state.pagination,
          totalCount: state.pagination.totalCount - 1,
        },
        deleteReferenceEntrySuccess: true,
      };
    }

    case actionTypes.DELETE_REFERENCE_ENTRY_FAILED:
      return {
        ...state,
        deleteReferenceEntryLoading: false,
        errorMessage: action.payload,
      };

    case actionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};
